
import { createApp } from 'vue';
import App from '@/App.vue'
import router from './router';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import dayjsConfig from './plugins/dayjs-config';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(ElementPlus, { locale: zhCn })
app.use(router);
app.use(dayjsConfig, {Antd});
app.use(Antd);
//挂载
app.mount('#app');
